import { FC, memo } from 'react';
import { Helmet } from 'react-helmet';
import { Routes } from './routes';
import { V4ThemeProvider, MessageToaster } from './components-v4';

import './components-v4/theme/fonts/roboto/roboto.css';
import './components-v4/theme/fonts/roboto-mono/roboto-mono.css';

export const RequestSinglePage: FC = memo(() => {
  return (
    <>
      <Helmet>
        <title>Страница заявки</title>
      </Helmet>

      <V4ThemeProvider>
        <MessageToaster />

        <div id="request-single-page-main-wrapper">
          <Routes />
        </div>

        <div id="dialogs-portal" />
      </V4ThemeProvider>
    </>
  );
});
